import axios, { AxiosRequestConfig } from 'axios';
import { useInflightTracker } from './useInflightTracker';
export interface AccountUpdates {
    username?: string
    password?: string
    email?: string
    challengeQuestionAndAnswers?: {
        question: string
        answer: string
    }[]
}

// Temporary username and password should be undefined for admin reset with mfa.
export interface UpdateAccountParams {
    usernamePasswordAuth?: {
        temporaryUsername: string
        temporaryPassword: string
    }
    updates: AccountUpdates
    headers: any
}

export interface UpdateAccoutError {
    type: string,
    message: string,
    name: string
}

export type UpdateAccountResponse = {
    code: 204,
    data: any; status: number
    statusText: string
    headers: any
    config: AxiosRequestConfig
    request?: any;
} | {
    code: number,
    errors: UpdateAccoutError[]
} | undefined

// Authorization for this endpoint uses either username/password, or update-account cookie (required for mfa users).
export const useUpdateAccountApi = () => {
    const tracker = useInflightTracker();

    const updateAccount = async ({usernamePasswordAuth, updates, headers}: UpdateAccountParams): Promise<UpdateAccountResponse> => {
        const url = '/account/api/update-account';
        if (tracker.isAlreadyInflight(url)) {
            return;
        }
        tracker.addApiCall(url);
        try {
            const response = await axios.post(
                url,
                {
                    username: usernamePasswordAuth?.temporaryUsername,
                    password: usernamePasswordAuth?.temporaryPassword,
                    updates
                },
                headers
            )
            tracker.removeApiCall(url);
            return {code: 204, ...response};
        } catch (error: any) {
            tracker.removeApiCall(url);
            if (error?.response?.data) {
                return {code: error.response.data.code, errors: error.response.data.errors};
            }
            return error;
        }

    };

    return {
        updateAccount,
    };
}
